/* Svensk katalog for locale-bank-kje09-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'bank.group.toast.booked': 'Matchningsgruppen har bokförts samlat.',
  'bank.group.err.bookUnavailable': 'Matchningsgruppen godkändes, men bokföring är inte tillgänglig.',
  'bank.group.err.bookFailed': 'Kunde inte bokföra matchningsgruppen.',
  'bank.group.book': 'Bokför grupp',
  'bank.resolve.reversePaymentInfo': 'Återföring upphäver betalningen med spårbarhet, öppnar leverantörsfakturan igen och öppnar bankraden för ny kontroll.',
  'err.bankMatchReversalReason': 'Ange en orsak till att bankkopplingen återförs.',
});
